export default __webpack_public_path__ + "static/media/Roblox_guest.47bfd475.png";